import { palette, withProp } from 'styled-tools';
export const bgColorWithProps = withProp(['opaque', 'palette', 'tone'], (opaque, paletteProp, tone = 0) => {
    if (!opaque) {
        return 'unset';
    }
    return palette(paletteProp, tone, 'unset');
});
export const textColorWithProps = withProp(['opaque', 'palette', 'tone'], (opaque, paletteProp, tone = 0) => palette(opaque ? `${paletteProp}Text` : paletteProp, tone, 'inherit'));

//# sourceMappingURL=styledProps.js.map
